const UUID_RE =
  /[0-9a-f]{8}-[0-9a-f]{4}-[1-5][0-9a-f]{3}-[89ab][0-9a-f]{3}-[0-9a-f]{12}/i;

const MESSAGE_TYPE_RE =
  /^message_thread:([0-9a-f-]{36})(?::([0-9a-f-]{36}))?(?::([0-9a-f-]{36}))?$/i;
const REFERRAL_TYPE_RE = /^referral_created:([0-9a-f-]{36})$/i;

function safeJsonParse(value) {
  if (!value || typeof value !== "string") return null;
  try {
    return JSON.parse(value);
  } catch {
    return null;
  }
}

function normalizeUuid(value) {
  const text = String(value || "").trim();
  return UUID_RE.test(text) ? text : "";
}

export function isMessageNotification(row) {
  const type = String(row?.type || "").trim();
  if (MESSAGE_TYPE_RE.test(type)) return true;

  const payload = safeJsonParse(row?.message);
  return Boolean(
    normalizeUuid(payload?.conversation_id || payload?.conversationId) ||
      normalizeUuid(payload?.message_id || payload?.messageId)
  );
}

export function deriveMessageNotificationTarget(row, fallbackState = null) {
  const directConversationId = normalizeUuid(
    fallbackState?.conversationId ||
      fallbackState?.conversation?.id ||
      fallbackState?.returnToState?.conversationId
  );
  const directParticipantUserId = normalizeUuid(
    fallbackState?.participantUserId ||
      fallbackState?.participant?.user_id ||
      fallbackState?.senderId
  );
  const directMessageId = normalizeUuid(
    fallbackState?.messageId || fallbackState?.message?.id
  );

  if (directConversationId) {
    return {
      conversationId: directConversationId,
      participantUserId: directParticipantUserId || null,
      messageId: directMessageId || null,
    };
  }

  const type = String(row?.type || "").trim();
  const typeMatch = type.match(MESSAGE_TYPE_RE);
  if (typeMatch?.[1]) {
    return {
      conversationId: normalizeUuid(typeMatch[1]),
      participantUserId: normalizeUuid(typeMatch[2]) || null,
      messageId: normalizeUuid(typeMatch[3]) || null,
    };
  }

  const payload = safeJsonParse(row?.message);
  const payloadConversationId = normalizeUuid(
    payload?.conversation_id || payload?.conversationId
  );

  if (!payloadConversationId) return null;

  return {
    conversationId: payloadConversationId,
    participantUserId: normalizeUuid(payload?.sender_id || payload?.senderId) || null,
    messageId: normalizeUuid(payload?.message_id || payload?.messageId) || null,
  };
}

export function isReferralNotification(row, fallbackState = null) {
  return Boolean(deriveReferralNotificationTarget(row, fallbackState)?.referralId);
}

export function deriveReferralNotificationTarget(row, fallbackState = null) {
  const directReferralId = normalizeUuid(
    fallbackState?.referralId ||
      fallbackState?.referral?.id ||
      fallbackState?.returnToState?.referralId
  );

  if (directReferralId) {
    return { referralId: directReferralId };
  }

  const type = String(row?.type || "").trim();
  const typeMatch = type.match(REFERRAL_TYPE_RE);
  if (typeMatch?.[1]) {
    return { referralId: normalizeUuid(typeMatch[1]) };
  }

  const payload = safeJsonParse(row?.message);
  const payloadReferralId = normalizeUuid(
    payload?.referral_id || payload?.referralId
  );

  if (!payloadReferralId) return null;

  return { referralId: payloadReferralId };
}
